export { default } from "./checked-icon";
